// extracted by mini-css-extract-plugin
module.exports = {"summaryContainer":"TradeRowHeader_summaryContainer__3BkdL","headingColumn":"TradeRowHeader_headingColumn__1mtps"};